import {BrowserModule} from '@angular/platform-browser';
import {NgModule, LOCALE_ID} from '@angular/core';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppRoutes} from './app-routing';
import {RouterModule} from '@angular/router';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {ServicosService} from './service/core/servicos.service';
import {AuthService} from './service/core/auth.service';
import {NgHttpLoaderComponentsModule} from 'ng-http-loader/components/ng-http-loader-components.module';
import {NgHttpLoaderServicesModule} from 'ng-http-loader/services/ng-http-loader-services.module';
import {AlertaService} from './service/core/alerta.service';
import {GrowlModule, ConfirmDialogModule} from 'primeng/primeng';
import {APP_BASE_HREF, registerLocaleData} from '@angular/common';
import { AuthGuard } from './service/core/auth-guard.service';
import { TokenInterceptor } from './service/core/interceptor.service';
import { ServicosGuard } from '@service/core/servicos-guard.service';
import localePt from '@angular/common/locales/pt';
import { RecursosHumanosService } from '@service/core/recursos-humanos.service';
import { CargoService } from '@service/core/cargo.service';

registerLocaleData(localePt, 'pt-BR');

@NgModule({
  imports: [
  RouterModule.forRoot(AppRoutes, { useHash: true }),
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgHttpLoaderServicesModule,
    NgHttpLoaderComponentsModule,
    GrowlModule,
    ConfirmDialogModule,
  ],
  declarations: [
    AppComponent,
  ],
  providers: [
    ServicosService,
    AuthService,
    RecursosHumanosService,
    AuthGuard,
    ServicosGuard,
    AlertaService,
    CargoService,
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts